import { HorizontalBar, mixins } from 'vue-chartjs'
import chartjsPluginAnnotation from 'chartjs-plugin-annotation';

export default {
  extends: HorizontalBar,
  props: {
    chart_labels: Array,
    chart_datasets: Array,
    chart_options: Object,
    individual_factor: Number,
    daily_factor: Number,
  },
  mounted () {
    this.render_chart_wrapper();
  },
  methods: {
    render_chart_wrapper(){

      // Lines and labels
      var originalDrawing = Chart.controllers.horizontalBar.prototype.draw;
      Chart.helpers.extend(Chart.controllers.horizontalBar.prototype, {
        draw: function() {
          originalDrawing.apply(this, arguments);

          var chart = this.chart;
          var ctx = chart.chart.ctx;
          var xaxis = chart.scales['x-axis-0'];
          var yaxis = chart.scales['y-axis-0'];

          if (chart.config.options.individual_factor && chart.config.options.daily_factor) {
            var midpoint = (xaxis.getPixelForValue(chart.config.options.individual_factor) + xaxis.getPixelForValue(chart.config.options.daily_factor)) / 2;
            var difference = chart.config.options.daily_factor - chart.config.options.individual_factor;

            // individual_factor line
            var x1 = xaxis.getPixelForValue(chart.config.options.individual_factor);
            var y1 = yaxis.top;
            var x2 = xaxis.getPixelForValue(chart.config.options.individual_factor);
            var y2 = yaxis.bottom;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.strokeStyle = 'black';
            ctx.strokeWidth = 2;
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.restore();

            // daily_factor line
            var x1 = xaxis.getPixelForValue(chart.config.options.daily_factor);
            var y1 = yaxis.top;
            var x2 = xaxis.getPixelForValue(chart.config.options.daily_factor);
            var y2 = yaxis.bottom;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.strokeStyle = 'black';
            ctx.strokeWidth = 2;
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.restore();

            // triangle left
            var x1 = xaxis.getPixelForValue(chart.config.options.individual_factor);
            var y1 = (yaxis.bottom / 2) - 42;
            var x2 = midpoint;
            var y2 = yaxis.top + 64;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.strokeStyle = 'black';
            ctx.strokeWidth = 2;
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.restore();

            // triangle right
            var x1 = midpoint;
            var y1 = yaxis.top + 64;
            var x2 = xaxis.getPixelForValue(chart.config.options.daily_factor);
            var y2 = (yaxis.bottom / 2) - 42;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.strokeStyle = 'black';
            ctx.strokeWidth = 2;
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.restore();

            // triangle label
            var txt = (difference > 0 ? '+' : '') + difference + ' Factor Difference';
            var x = midpoint;
            var y = 48;
            var width = ctx.measureText(txt).width;
            ctx.save();
            ctx.font = '16px Arial';
            ctx.fontWeight = 'bold';
            ctx.textAlign = 'center';
            ctx.fillStyle = '#000';
            ctx.fillText(txt, x, y);
            ctx.restore();

            // individual_factor label
            var txt = 'Individual Factor';
            var x = xaxis.getPixelForValue(chart.config.options.individual_factor);
            var y = yaxis.bottom - 24;
            var width = ctx.measureText(txt).width;
            ctx.save();
            ctx.font = '16px Arial';
            ctx.fontWeight = 'bold';
            ctx.textAlign = 'right';
            ctx.fillStyle = '#000';
            ctx.fillText(txt, x - 8, y);
            ctx.restore();

            // daily_factor label
            var txt = 'Daily Factor';
            var x = xaxis.getPixelForValue(chart.config.options.daily_factor);
            var y = yaxis.bottom - 24;
            var width = ctx.measureText(txt).width;
            ctx.save();
            ctx.font = '16px Arial';
            ctx.fontWeight = 'bold';
            ctx.textAlign = 'right';
            ctx.fillStyle = '#000';
            ctx.fillText(txt, x - 8, y);
            ctx.restore();
          }
        }
      });

      console.log("dailymealfactors rechart");
      console.log(this.chart_labels);
      console.log(this.chart_datasets);
      this.addPlugin(chartjsPluginAnnotation),

      this.renderChart({
        labels: this.chart_labels,
        datasets: this.chart_datasets,
      }, jQuery.extend(true, {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          mode: 'nearest',
        },
        scales: {
          yAxes: [{
            stacked: true,
            gridLines: {
              display: false,
            },
          }],
          xAxes: [{
            stacked: true,
            gridLines: {
              display: true,
            },
            ticks: {
              beginAtZero: true,
              min: 0,
              max: (this.individual_factor || this.daily_factor) ? Math.max(this.individual_factor, this.daily_factor) : 21,
              stepSize: 1,
            },

          }],
        },
        plugins: {
          datalabels: {
            display: true,
            color: '#fff',
            formatter: function(value, context) {
              if (value >= 4) {
                return context.dataset.label + ': ' + value;
              } else if (value > 0) {
                return '( i )';
              } else {
                return '';
              }
            },
          },
        },
        individual_factor: this.individual_factor,
        daily_factor: this.daily_factor,
      }, this.chart_options));
    }
  },
  watch: {
    chart_labels: function(){
      this.$data._chart.destroy();
      this.render_chart_wrapper();
      this.$data._chart.update();
    },
    'chart_datasets.0.data': {
      handler(v) {
        this.$data._chart.destroy();
        this.render_chart_wrapper();
        this.$data._chart.update();
      },
      deep: true,
    },
    'chart_datasets.1.data': {
      handler(v) {
        this.$data._chart.destroy();
        this.render_chart_wrapper();
        this.$data._chart.update();
      },
      deep: true,
    },
    'chart_datasets.2.data': {
      handler(v) {
        this.$data._chart.destroy();
        this.render_chart_wrapper();
        this.$data._chart.update();
      },
      deep: true,
    },
    'chart_datasets.3.data': {
      handler(v) {
        this.$data._chart.destroy();
        this.render_chart_wrapper();
        this.$data._chart.update();
      },
      deep: true,
    },
  }
}
